import { FC, useEffect, useState } from "react";
import PopupModal from "../../../UI/Popup";
import TextInput from "../../../UI/Inputs/TextInput";
import CustomButton from "../../../UI/Buttons/CustomButton";
import { useAppSelector as useSelector, useAppDispatch as useDispatch } from "../../../../store";
import { submitJobAdderIdThunk } from "../../../../store/superadmin/thunks";
import { setJobAdderIdPopupShowAction } from "../../../../store/superadmin/slice";

const JobAdderId: FC = () => {
    const dispatch = useDispatch();

    const inProgress = useSelector((state) => state.superadmin.inProgress);
    const popUpDetails = useSelector((state) => state.superadmin.showJobAdderPopup)

    const [jobAdderId, setJobAdderId] = useState<string | null>(null)

    useEffect(() => {
        if(!popUpDetails?.showPopupModal) {
            setJobAdderId(null)
        }
    }, [popUpDetails])

    const onClickClose = () => {
        dispatch(setJobAdderIdPopupShowAction({showPopupModal: false, candidateUuid: null}))
        document.body.classList.remove("modal-open");
    };

    const handleSubmitJobAdderId = async () => {
        dispatch(submitJobAdderIdThunk({jobAdderId: jobAdderId, candidate_uuid: popUpDetails !== null ? popUpDetails?.candidateUuid : null}))
    }

    return (
        <>
            <PopupModal
                visible={popUpDetails?.showPopupModal ?? false}
                showCloseBtn={true}
                onClickClose={onClickClose}
                customWidth={450}
            >
                <div className="d-flex flex-column gap-20">
                    <div className="d-flex flex-column gap-15">
                    <div className="fs-22 fw-400 text-black">
                        JobAdder ID
                    </div>
                    <TextInput
                        value={jobAdderId ?? ""}
                        field={"job_adder_id"}
                        label={"JobAdder Id"}
                        onChange={(e) => setJobAdderId(e.target.value)}
                        placeholder={" " + ""}
                    />
                    </div>
                    <div className="d-flex justify-content-end">
                    <CustomButton
                        variant={"primary"}
                        type="button"
                        className="btn-theme bg-teal text-black"
                        contentClass="d-flex"
                        isLoading={inProgress}
                        onClick={handleSubmitJobAdderId}
                    >
                        Submit
                    </CustomButton>
                    </div>
                </div>
            </PopupModal>
        </>
    )
}

export default JobAdderId;